// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BaLnL","input":"styles_input__1uVAD"};